import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsPatientWeekQueryKey({
  personaName,
  date
}: {
  personaName?: string
  date: string
}) {
  return ['operationalCAAMetricsPatientWeek', { personaName, date }]
}

export function useOperationalCAAMetricsPatientWeekQuery({
  personaName,
  date,
  enabled
}: {
  personaName?: string
  date: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsPatientWeekQueryKey({
      personaName,
      date
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsPatientWeek({
        personaName,
        date
      }),
    enabled
  })
}
